import { useCallback } from 'react';

import { setLocation } from 'js/lib/coursera.redirect';

import { fromId as getCourseMaterialsById } from 'pages/open-course/common/data/courseMaterials';

type Props = {
  courseSlug: string;
  courseId: string;
  onError: (error: unknown) => void;
};

const useNavigateToSkillContent = ({ courseSlug, courseId, onError }: Props) => {
  const navigateToAssessment = useCallback(
    (assessmentId: string) => {
      setLocation(`/learn/${courseSlug}/assignment-submission/${assessmentId}`);
    },
    [courseSlug]
  );

  const navigateToCourse = useCallback(async () => {
    try {
      const courseMaterialsResponse = await getCourseMaterialsById(courseId);
      const firstCourseItem = courseMaterialsResponse?.elements?.[0]?.elements?.[0]?.elements?.[0];
      const itemSlug = firstCourseItem?.slug;
      const itemId = firstCourseItem?.id;
      const itemType = firstCourseItem?.contentSummary?.typeName;

      if (itemSlug && itemId && itemType) {
        setLocation(`/learn/${courseSlug}/${itemType}/${itemId}/${itemSlug}`);
      } else {
        setLocation(`/learn/${courseSlug}/home/welcome`);
      }
    } catch (error: unknown) {
      onError(error);
    }
  }, [courseSlug, courseId, onError]);

  return { navigateToAssessment, navigateToCourse };
};

export default useNavigateToSkillContent;
